import { BrowserRouter, Routes, Route } from "react-router";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthPage, ErrorPage } from "./pages";
import { Helmet } from "react-helmet-async";
import { useTheme } from "./hooks";

import Layout from "./components/layout";

const queryClient = new QueryClient();

function App() {
  const { theme } = useTheme();

  return (
    <>
      <Helmet htmlAttributes={{ class: theme }}>
        <title>Collectr - Sign in</title>
        <link rel='canonical' href='https://auth.getcollectr.com/' />
      </Helmet>

      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route index path='/' element={<AuthPage />} />
              <Route path='/:rid/:username' element={<AuthPage />} />
              <Route path='/:rid' element={<AuthPage />} />
              <Route path='error' element={<ErrorPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </>
  );
}

export default App;
